

export default function isDrivers({ next, store, nextMiddleware }) {
  if (!store.GET_CONNECT_ID) {
    return next({
      name: "insurance.drivers",
    });
  }

  return nextMiddleware();
}
